import { redirect, type RouteObject } from 'react-router'

import { routeCrumb } from '../client/components/Admin/TopNavBar/utils/routeCrumb.js'

export const settingsRoutes: RouteObject = {
  path: 'settings',
  async lazy() {
    const { SettingsRouteBreadCrumb } = await import(
      '../client/components/Settings/SettingsRoute.js'
    )
    const { SettingsRouteWrapper } = await import(
      '../client/components/Admin/Settings/routes/SettingsRouteWrapper.js'
    )

    return {
      Component: SettingsRouteWrapper,
      handle: routeCrumb(SettingsRouteBreadCrumb),
    }
  },
  children: [
    {
      index: true,
      loader: () => redirect('network'),
    },
    {
      path: 'network',
      async lazy() {
        const { NetworkBreadCrumb } = await import(
          '../client/components/Admin/Settings/CommunitySettings/index.js'
        )
        const { SettingsOutlet } = await import(
          '../client/components/Admin/Settings/routes/SettingsOutlet.js'
        )

        return {
          Component: SettingsOutlet,
          handle: routeCrumb(NetworkBreadCrumb),
        }
      },
      children: [
        {
          index: true,
          loader: () => redirect('general'),
        },
        {
          path: 'general',
          async lazy() {
            const {
              CommunityGeneralSettingsRouter,
              CommunityGeneralSettingsBreadCrumb,
            } = await import(
              '../client/components/Admin/Settings/CommunitySettings/routes/CommunityGeneralSettingsRoute.js'
            )

            return {
              Component: CommunityGeneralSettingsRouter,
              handle: routeCrumb(CommunityGeneralSettingsBreadCrumb),
            }
          },
        },
        {
          path: 'publish',
          async lazy() {
            const {
              CommunityPublishSettingsRouter,
              CommunityPublishSettingsBreadCrumb,
            } = await import(
              '../client/components/Admin/Settings/CommunitySettings/routes/CommunityPublishSettingsRoute.js'
            )

            return {
              Component: CommunityPublishSettingsRouter,
              handle: routeCrumb(CommunityPublishSettingsBreadCrumb),
            }
          },
        },
        {
          path: 'permissions',
          async lazy() {
            const {
              CommunityPermissionsSettingsRouter,
              CommunityPermissionsSettingsBreadCrumb,
            } = await import(
              '../client/components/Admin/Settings/CommunitySettings/routes/CommunityPermissionsSettingsRoute.js'
            )

            return {
              Component: CommunityPermissionsSettingsRouter,
              handle: routeCrumb(CommunityPermissionsSettingsBreadCrumb),
            }
          },
        },
        {
          path: 'homepage',
          async lazy() {
            const {
              CommunityHomepageSettingsRouter,
              CommunityHomepageSettingsBreadCrumb,
            } = await import(
              '../client/components/Admin/Settings/CommunitySettings/routes/CommunityHomepageSettingsRoute.js'
            )

            return {
              Component: CommunityHomepageSettingsRouter,
              handle: routeCrumb(CommunityHomepageSettingsBreadCrumb),
            }
          },
        },
        {
          path: 'default-spaces',
          async lazy() {
            const {
              CommunityDefaultSpacesSettingsRouter,
              CommunityDefaultSpacesSettingsBreadCrumb,
            } = await import(
              '../client/components/Admin/Settings/CommunitySettings/routes/CommunityDefaultSpacesSettingsRoute.js'
            )

            return {
              Component: CommunityDefaultSpacesSettingsRouter,
              handle: routeCrumb(CommunityDefaultSpacesSettingsBreadCrumb),
            }
          },
        },
        {
          path: 'media',
          async lazy() {
            const {
              CommunityMediaSettingsRouter,
              CommunityMediaSettingsBreadCrumb,
            } = await import(
              '../client/components/Admin/Settings/CommunitySettings/routes/CommunityMediaSettingsRoute.js'
            )

            return {
              Component: CommunityMediaSettingsRouter,
              handle: routeCrumb(CommunityMediaSettingsBreadCrumb),
            }
          },
        },
        {
          path: 'white-label',
          async lazy() {
            const {
              CommunityWhiteLabelSettingsRouter,
              CommunityWhiteLabelSettingsBreadCrumb,
            } = await import(
              '../client/components/Admin/Settings/CommunitySettings/routes/CommunityWhiteLabelSettingsRoute.js'
            )

            return {
              Component: CommunityWhiteLabelSettingsRouter,
              handle: routeCrumb(CommunityWhiteLabelSettingsBreadCrumb),
            }
          },
        },
        {
          path: 'other',
          async lazy() {
            const {
              CommunityOtherSettingsRouter,
              CommunityOtherSettingsBreadCrumb,
            } = await import(
              '../client/components/Admin/Settings/CommunitySettings/routes/CommunityOtherSettingsRoute.js'
            )

            return {
              Component: CommunityOtherSettingsRouter,
              handle: routeCrumb(CommunityOtherSettingsBreadCrumb),
            }
          },
        },
      ],
    },
    {
      path: 'localization',
      async lazy() {
        const { LocalizationBreadCrumb } = await import(
          '../client/components/Admin/Settings/Localization/index.js'
        )
        const { SettingsOutlet } = await import(
          '../client/components/Admin/Settings/routes/SettingsOutlet.js'
        )

        return {
          Component: SettingsOutlet,
          handle: routeCrumb(LocalizationBreadCrumb),
        }
      },
      children: [
        {
          index: true,
          loader: () => redirect('community-language'),
        },
        {
          path: 'community-language',
          async lazy() {
            const { CommunityLanguageRouter, CommunityLanguageBreadCrumb } =
              await import(
                '../client/components/Admin/Settings/Localization/routes/CommunityLanguageRoute.js'
              )

            return {
              Component: CommunityLanguageRouter,
              handle: routeCrumb(CommunityLanguageBreadCrumb),
            }
          },
        },
        {
          path: 'post-translation',
          async lazy() {
            const { PostTranslationRouter, PostTranslationBreadCrumb } =
              await import(
                '../client/components/Admin/Settings/Localization/routes/PostTranslationRoute.js'
              )

            return {
              Component: PostTranslationRouter,
              handle: routeCrumb(PostTranslationBreadCrumb),
            }
          },
        },
      ],
    },
    {
      path: 'search',
      async lazy() {
        const { SearchBreadCrumb } = await import(
          '../client/components/Admin/Settings/Search/index.js'
        )
        const { SettingsOutlet } = await import(
          '../client/components/Admin/Settings/routes/SettingsOutlet.js'
        )

        return {
          Component: SettingsOutlet,
          handle: routeCrumb(SearchBreadCrumb),
        }
      },
      children: [
        {
          index: true,
          loader: () => redirect('search-sources'),
        },
        {
          path: 'search-sources',
          async lazy() {
            const { SearchSourcesRouter, SearchSourcesBreadCrumb } =
              await import(
                '../client/components/Admin/Settings/Search/routes/SearchSourcesRoute.js'
              )

            return {
              Component: SearchSourcesRouter,
              handle: routeCrumb(SearchSourcesBreadCrumb),
            }
          },
        },
        {
          path: 'official-resources',
          async lazy() {
            const { OfficialResourcesRouter, OfficialResourcesBreadCrumb } =
              await import(
                '../client/components/Admin/Settings/Search/routes/OfficialResourcesRoute.js'
              )

            return {
              Component: OfficialResourcesRouter,
              handle: routeCrumb(OfficialResourcesBreadCrumb),
            }
          },
        },
        {
          path: 'ask-ai',
          async lazy() {
            const { AskAIRouter, AskAIBreadCrumb } = await import(
              '../client/components/Admin/Settings/Search/routes/AskAIRoute.js'
            )

            return {
              Component: AskAIRouter,
              handle: routeCrumb(AskAIBreadCrumb),
            }
          },
        },
        {
          path: 'federated-search',
          async lazy() {
            const { FederatedSearchRouter, FederatedSearchBreadCrumb } =
              await import(
                '../client/components/Admin/Settings/Search/routes/FederatedSearchRoute.js'
              )

            return {
              Component: FederatedSearchRouter,
              handle: routeCrumb(FederatedSearchBreadCrumb),
            }
          },
        },
      ],
    },
    {
      path: 'authentication',
      async lazy() {
        const { SettingsOutlet } = await import(
          '../client/components/Admin/Settings/routes/SettingsOutlet.js'
        )

        return {
          Component: SettingsOutlet,
        }
      },
      children: [
        {
          index: true,
          loader: () => redirect('email'),
        },
        {
          path: 'email',
          async lazy() {
            const { EmailAuthRouter, EmailAuthBreadCrumb } = await import(
              '../client/components/Admin/Settings/Authentication/routes/EmailAuthRoute.js'
            )

            return {
              Component: EmailAuthRouter,
              handle: routeCrumb(EmailAuthBreadCrumb),
            }
          },
        },
        {
          path: 'social',
          async lazy() {
            const { SocialAuthRouter, SocialAuthBreadCrumb } = await import(
              '../client/components/Admin/Settings/Authentication/routes/SocialAuthRoute.js'
            )

            return {
              Component: SocialAuthRouter,
              handle: routeCrumb(SocialAuthBreadCrumb),
            }
          },
        },
        {
          path: 'oauth2',
          async lazy() {
            const { OAuth2AuthRouter, OAuth2AuthBreadCrumb } = await import(
              '../client/components/Admin/Settings/Authentication/routes/OAuth2AuthRoute.js'
            )

            return {
              Component: OAuth2AuthRouter,
              handle: routeCrumb(OAuth2AuthBreadCrumb),
            }
          },
        },
        {
          path: 'jwt',
          async lazy() {
            const { JwtAuthRouter, JwtAuthBreadCrumb } = await import(
              '../client/components/Admin/Settings/Authentication/routes/JwtAuthRoute.js'
            )

            return {
              Component: JwtAuthRouter,
              handle: routeCrumb(JwtAuthBreadCrumb),
            }
          },
        },
        {
          path: 'saml',
          async lazy() {
            const { SamlAuthRouter, SamlAuthBreadCrumb } = await import(
              '../client/components/Admin/Settings/Authentication/routes/SamlAuthRoute.js'
            )

            return {
              Component: SamlAuthRouter,
              handle: routeCrumb(SamlAuthBreadCrumb),
            }
          },
        },
      ],
    },
    {
      path: 'domain',
      async lazy() {
        const { DomainSectionRoute, DomainBreadCrumb } = await import(
          '../client/components/Admin/Settings/Domain/DomainRoute.js'
        )

        return {
          Component: DomainSectionRoute,
          handle: routeCrumb(DomainBreadCrumb),
        }
      },
    },
    {
      path: 'messaging',
      async lazy() {
        const { MessagingBreadCrumb } = await import(
          '../client/components/Admin/Messaging/index.js'
        )
        const { SettingsOutlet } = await import(
          '../client/components/Admin/Settings/routes/SettingsOutlet.js'
        )

        return {
          Component: SettingsOutlet,
          handle: routeCrumb(MessagingBreadCrumb),
        }
      },
      children: [
        {
          index: true,
          loader: () => redirect('global'),
        },
        {
          path: 'global',
          async lazy() {
            const { GlobalMessagingRouter, GlobalMessagingBreadCrumb } =
              await import(
                '../client/components/Admin/Messaging/routes/GlobalMessagingRoute.js'
              )

            return {
              Component: GlobalMessagingRouter,
              handle: routeCrumb(GlobalMessagingBreadCrumb),
            }
          },
        },
        {
          path: 'members',
          async lazy() {
            const { MembersMessagingRouter, MembersMessagingBreadCrumb } =
              await import(
                '../client/components/Admin/Messaging/routes/MembersMessagingRoute.js'
              )

            return {
              Component: MembersMessagingRouter,
              handle: routeCrumb(MembersMessagingBreadCrumb),
            }
          },
        },
        {
          path: 'groups',
          async lazy() {
            const { GroupsMessagingRouter, GroupsMessagingBreadCrumb } =
              await import(
                '../client/components/Admin/Messaging/routes/GroupsMessagingRoute.js'
              )

            return {
              Component: GroupsMessagingRouter,
              handle: routeCrumb(GroupsMessagingBreadCrumb),
            }
          },
        },
      ],
    },
    {
      path: 'notifications',
      async lazy() {
        const { NotificationsBreadCrumb } = await import(
          '../client/components/Admin/Settings/Notifications/index.js'
        )
        const { SettingsOutlet } = await import(
          '../client/components/Admin/Settings/routes/SettingsOutlet.js'
        )

        return {
          Component: SettingsOutlet,
          handle: routeCrumb(NotificationsBreadCrumb),
        }
      },
      children: [
        {
          index: true,
          loader: () => redirect('email-notifications'),
        },
        {
          path: 'email-notifications',
          async lazy() {
            const { EmailNotificationRouter, EmailNotificationBreadCrumb } =
              await import(
                '../client/components/Admin/Settings/Notifications/routes/EmailNotificationRoute.js'
              )

            return {
              Component: EmailNotificationRouter,
              handle: routeCrumb(EmailNotificationBreadCrumb),
            }
          },
        },
        {
          path: 'email-digest',
          async lazy() {
            const { EmailDigestRouter, EmailDigestBreadCrumb } = await import(
              '../client/components/Admin/Settings/Notifications/routes/EmailDigestRoute.js'
            )

            return {
              Component: EmailDigestRouter,
              handle: routeCrumb(EmailDigestBreadCrumb),
            }
          },
        },
        {
          path: 'from-email',
          async lazy() {
            const { FromEmailRouter, FromEmailBreadCrumb } = await import(
              '../client/components/Admin/Settings/Notifications/routes/FromEmailRoute.js'
            )

            return {
              Component: FromEmailRouter,
              handle: routeCrumb(FromEmailBreadCrumb),
            }
          },
        },
      ],
    },
    {
      path: 'seo',
      async lazy() {
        const { SeoSettingsBreadCrumb } = await import(
          '../client/components/Admin/Settings/SeoSettings/SeoSettings.js'
        )
        const { SettingsOutlet } = await import(
          '../client/components/Admin/Settings/routes/SettingsOutlet.js'
        )

        return {
          Component: SettingsOutlet,
          handle: routeCrumb(SeoSettingsBreadCrumb),
        }
      },
      children: [
        {
          index: true,
          loader: () => redirect('seo'),
        },
        {
          path: 'seo',
          async lazy() {
            const { SeoRouter, SeoBreadCrumb } = await import(
              '../client/components/Admin/Settings/SeoSettings/routes/SeoRoute.js'
            )

            return {
              Component: SeoRouter,
              handle: routeCrumb(SeoBreadCrumb),
            }
          },
        },
      ],
    },
    {
      path: 'security',
      async lazy() {
        const { SecurityBreadCrumb } = await import(
          '../client/components/Admin/Security/index.js'
        )
        const { SettingsOutlet } = await import(
          '../client/components/Admin/Settings/routes/SettingsOutlet.js'
        )

        return {
          Component: SettingsOutlet,
          handle: routeCrumb(SecurityBreadCrumb),
        }
      },
      children: [
        {
          index: true,
          loader: () => redirect('password-strength'),
        },
        {
          path: 'password-strength',
          async lazy() {
            const { PasswordStrengthRouter, PasswordStrengthBreadCrumb } =
              await import(
                '../client/components/Admin/Security/routes/PasswordStrengthRoute.js'
              )

            return {
              Component: PasswordStrengthRouter,
              handle: routeCrumb(PasswordStrengthBreadCrumb),
            }
          },
        },
        {
          path: 'captcha',
          async lazy() {
            const { CaptchaRouter, CaptchaBreadCrumb } = await import(
              '../client/components/Admin/Security/routes/CaptchaRoute.js'
            )

            return {
              Component: CaptchaRouter,
              handle: routeCrumb(CaptchaBreadCrumb),
            }
          },
        },
        {
          path: 'embed',
          async lazy() {
            const { EmbedRouter, EmbedBreadCrumb } = await import(
              '../client/components/Admin/Security/routes/EmbedRoute.js'
            )

            return {
              Component: EmbedRouter,
              handle: routeCrumb(EmbedBreadCrumb),
            }
          },
        },
        {
          path: 'privacy',
          async lazy() {
            const { PrivacyRouter, PrivacyBreadCrumb } = await import(
              '../client/components/Admin/Security/routes/PrivacyRoute.js'
            )

            return {
              Component: PrivacyRouter,
              handle: routeCrumb(PrivacyBreadCrumb),
            }
          },
        },
      ],
    },
    {
      path: 'moderation',
      async lazy() {
        const { ModerationSettingsBreadCrumb } = await import(
          '../client/components/Admin/ModerationSettings/index.js'
        )
        const { SettingsOutlet } = await import(
          '../client/components/Admin/Settings/routes/SettingsOutlet.js'
        )

        return {
          Component: SettingsOutlet,
          handle: routeCrumb(ModerationSettingsBreadCrumb),
        }
      },
      children: [
        {
          index: true,
          loader: () => redirect('ai-spam'),
        },
        {
          path: 'ai-spam',
          async lazy() {
            const { AISpamDetectorRouter, AISpamDetectorBreadCrumb } =
              await import(
                '../client/components/Admin/ModerationSettings/routes/AISpamDetectorRoute.js'
              )

            return {
              Component: AISpamDetectorRouter,
              handle: routeCrumb(AISpamDetectorBreadCrumb),
            }
          },
        },
        {
          path: 'alerts',
          async lazy() {
            const { ModerationAlertsRouter, ModerationAlertsBreadCrumb } =
              await import(
                '../client/components/Admin/ModerationSettings/routes/ModerationAlertsRoute.js'
              )

            return {
              Component: ModerationAlertsRouter,
              handle: routeCrumb(ModerationAlertsBreadCrumb),
            }
          },
        },
        {
          path: 'monitored-contents',
          async lazy() {
            const { ModeratedContentsRouter, ModeratedContentsBreadCrumb } =
              await import(
                '../client/components/Admin/ModerationSettings/routes/ModeratedContentsRoute.js'
              )

            return {
              Component: ModeratedContentsRouter,
              handle: routeCrumb(ModeratedContentsBreadCrumb),
            }
          },
        },
        {
          path: 'age-based',
          async lazy() {
            const { AgedBasedModerationRouter, AgedBasedModerationBreadCrumb } =
              await import(
                '../client/components/Admin/ModerationSettings/routes/AgedBasedModerationRoute.js'
              )

            return {
              Component: AgedBasedModerationRouter,
              handle: routeCrumb(AgedBasedModerationBreadCrumb),
            }
          },
        },
        {
          path: 'flagged-members',
          async lazy() {
            const { FlaggedMembersRouter, FlaggedMembersBreadCrumb } =
              await import(
                '../client/components/Admin/ModerationSettings/routes/FlaggedMembersRoute.js'
              )

            return {
              Component: FlaggedMembersRouter,
              handle: routeCrumb(FlaggedMembersBreadCrumb),
            }
          },
        },
      ],
    },
  ],
}
